import { Component, OnDestroy, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserAccountService } from '../../../common/service/user-account.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { LocalDate } from '../../../core/model/local-date';
import { LanguageService } from '../../../core/service/language.service';
import { Money } from '../../../core/model/money';
import { CompanyMortgageService } from '../../service/company-mortgage.service';
import { CompanyMortgage } from '../../model/company-mortgage';

@Component({
    selector: 'app-add-amortization',
    templateUrl: './add-amortization.component.html',
    styleUrls: ['./add-amortization.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddAmortizationComponent implements OnDestroy, OnInit {
  constructor(
    private _fcf: FormControlExFactory,
    private _modalService: ActionWindowService,
    private _service: CompanyMortgageService,
    private _fb: FormBuilder
  ) {}
  ngOnInit(): void {
    this.form = this._fb.group({
      companyMortgageId: this._fcf.createHidden(this.dataContext ? this.dataContext.id : null),
      paymentDate: this._fcf.createMandatory('REGISTER_PAYMENT.DATE', null),
      amount: this._fcf.createMandatory(
        'COMMON.AMOUNT',
        this.dataContext ? new Money(this.dataContext.initialAmount.currencyCode, null) : null
      ),
    });
  }

  private _dataContext: CompanyMortgage;
  @Input() set dataContext(value: CompanyMortgage) {
    this._dataContext = value;
    if (this.form) {
      this.form.controls['amount'].setValue(new Money(this._dataContext.balance.currencyCode, null));
      this.form.controls['companyMortgageId'].setValue(this._dataContext.id);
    }
  }

  get dataContext(): CompanyMortgage {
    return this._dataContext;
  }

  private _subscription: Subscription;

  form: FormGroup;

  cancel() {
    this._modalService.close();
  }

  onSubmit() {
    if (this.form.valid) {
      if (this._subscription) {
        this._subscription.unsubscribe();
      }
      this._subscription = this._service
        .addAmortization(this.dataContext.id, this.form.controls['amount'].value, this.form.controls['paymentDate'].value)
        .subscribe(res => {
          this._modalService.complete(res);
        });
    }
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
  }
}
